import React, { useState } from 'react';
import classes from "./UserLogs.module.css";
import Layout from '../components/Layout';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { userLogsApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from "moment-timezone";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { removeToken } from '../store/slices/tokenSlice';
import Spinner from '../components/Spinner';

const UserLogs = () => {
    const [msisdn, setMsisdn] = useState("");
    const { token } = useSelector(state => state?.tokenSlice);

    const [loading,setLoading]=useState(false);
    const [subscriptionLogs, setSubscriptionLogs] = useState(null);
    const [billingLogs, setBillingLogs] = useState(null);
    const [unsubscriptionLogs, setUnsubcriptionLogs] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchUserLogs = async (e) => {
        try {
            e.preventDefault();
            if(!msisdn){
                return;
            }
            setLoading(true);
            const response = await userLogsApi(msisdn, token);
            console.log(response?.data?.result, 'result...');
            setSubscriptionLogs(response?.data?.result?.subscription_logs ?? null);
            setUnsubcriptionLogs(response?.data?.result?.unsubscription_logs ?? null);
            setBillingLogs(response?.data?.result?.billing_logs ?? null);
            setLoading(false);

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);


            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Token Expired, Please Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }
    return (
        <Layout active={1}>

            <div className={classes.message_container}>
                <p className={classes.message_title}>User Logs</p>
            </div>

            <form className={classes.search_container} onSubmit={fetchUserLogs}>
                <InputNumber value={msisdn} onValueChange={(e) => setMsisdn(e.value)} useGrouping={false} placeholder="Enter User Number"
                    maxLength={10}
                />
                <Button label='Search' type='submit' />
            </form>

            {loading && <Spinner />}

            {
                subscriptionLogs && (
                    <div className={classes.table_container}>
                        <DataTable
                            value={[...subscriptionLogs]}
                            emptyMessage="User is not subscribed!"
                            showGridlines
                            responsive
                            scrollable
                            scrollDirection="both"
                            header={
                                <p className={classes.table_header}>
                                    Subscription Details
                                </p>
                            }
                            scrollHeight="500px"
                        >
                            <Column field="sub_date_time" header="Subscription Date Time"
                                body={(rowData) =>
                                    moment(rowData?.sub_date_time).format("DD-MM-YYYY")
                                }
                            />
                            <Column
                                field="msisdn"
                                header="Msisdn"
                            />
                            <Column
                                field="name"
                                header="Name"
                            />
                            <Column
                                field="image"
                                header="Image"
                                body={(rowData) =>
                                    rowData?.image != null ? <img src={rowData?.image} alt="avatar" style={{ width: "64px", height: "64px", objectFit: "contain" }} />
                                        : "No Image"
                                }

                            />
                            <Column
                                field="total_points"
                                header="Total Points"

                            />
                            <Column
                                field="next_billing_date"
                                header="Next Billing Date"
                                body={(rowData) =>
                                    moment(rowData?.next_billing_date).format("DD-MM-YYYY")
                                }
                            />
                            <Column
                                field="sub_type"
                                header="Subscription Type"
                            />

                        </DataTable>
                    </div>
                )
            }

            {
                billingLogs && (
                    <div className={classes.table_container}>
                        <DataTable
                            value={[...billingLogs]}
                            emptyMessage="No Billing Details Found!"
                            showGridlines
                            responsive
                            scrollable
                            scrollDirection="both"
                            scrollHeight="500px"
                            header={
                                <p className={classes.table_header}>
                                    Billing Details
                                </p>
                            }
                        >
                            <Column field="msisdn" header="Msisdn"
                            />
                            <Column
                                field="billing_date"
                                header="Billing Date Time"
                                body={(rowData) =>
                                    moment(rowData?.billing_date).toLocaleString()
                                }
                            />
                            <Column
                                field="next_billing_date"
                                header="Next Billing Date"
                                body={(rowData) =>
                                    moment(rowData?.next_billing_date).format("DD-MM-YYYY")
                                }
                            />
                            <Column
                                field="pack_type"
                                header="Pack Type"
                            />
                            <Column
                                field="amount"
                                header="Amount"
                            />
                            <Column
                                field="currency"
                                header="Currency"
                            />
                            <Column
                                field="sub_type"
                                header="Subscription Type"
                            />

                        </DataTable>
                    </div>
                )
            }

            {
                unsubscriptionLogs && (
                    <div className={classes.table_container}>
                        <DataTable
                            value={[...unsubscriptionLogs]}
                            emptyMessage="No Unsubscription Details Found!"
                            showGridlines
                            responsive
                            scrollable
                            scrollDirection="both"
                            scrollHeight="500px"
                            header={
                                <p className={classes.table_header}>
                                    Unsubscription Details
                                </p>
                            }
                        >
                            <Column field="msisdn" header="Msisdn"
                            />
                            <Column
                                field="unsub_date"
                                header="Billing Date Time"
                                body={(rowData) =>
                                    moment(rowData?.unsub_date).toLocaleString()
                                }
                            />
                            <Column
                                field="pack_type"
                                header="Pack Type"
                            />
                            <Column
                                field="price"
                                header="Amount"
                            />
                        </DataTable>
                    </div>
                )
            }
        </Layout>
    )
}

export default UserLogs